import { render, staticRenderFns } from "./AverageTicketCard.vue?vue&type=template&id=737be292"
import script from "./AverageTicketCard.vue?vue&type=script&lang=js"
export * from "./AverageTicketCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports